import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Link from 'components/Link';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import s from './TrendingSlider.scss';

const TrendingSlider = props => {
  const { topSearches, title, ga4Type } = props;

  if (!(Array.isArray(topSearches) && topSearches.length > 0)) return null;

  const PrevArrow = sliderProps => {
    const { className } = sliderProps;
    return (
      <button
        {...sliderProps}
        className={`${s.arrow} ${s.left} ${className}`}
        aria-label="left align"
      />
    );
  };

  const NextArrow = sliderProps => {
    const { className } = sliderProps;
    return (
      <button
        {...sliderProps}
        className={`${s.arrow} ${s.right} ${className}`}
        aria-label="right align"
      />
    );
  };

  const settings = {
    className: 'slider variable-width',
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    variableWidth: true,
  };

  const getItemGA = (itemText, index, wu) => {
    // const { gaCategory, gaAction } = this.props;
    const gaWithCategoryAction = `click-topSearches-${index}|${wu && wu}`;

    return gaWithCategoryAction;
  };

  return (
    <div className={`${s.sliderWrapper} ${s.trending_wrapper}`}>
      <div className={s.sliderHeading}>{title || 'Trending'}</div>
      <div className="trending_sliderContent">
        <Slider {...settings}>
          {topSearches.map((item, index) => {
            const itemTitle = item.pillTitle || item.hl || item.title || '';
            const variableWidthSlider = `${itemTitle.length + 100} px`;
            // let content = item.hl || item.title;
            // if (item.title && item.content) {
            //   itemTitle = item.title;
            //   content = item.content;
            // }
            return (
              <div
                className={`${s.sliderItem}`}
                style={{ width: variableWidthSlider }}
              >
                {itemTitle ? (
                  <span className={s.sliderItemLink}>
                    <Link
                      key={item.id}
                      to={item.wu || item.link}
                      className="keyword"
                      data-ga={`${getItemGA(
                        itemTitle,
                        index + 1,
                        item.wu || item.link,
                      )}`}
                      target={item.target === '_blank' ? item.target : ''}
                      ga4Data={[
                        {
                          event: 'user_click',
                          type: ga4Type || 'trending_topics',
                          label: itemTitle,
                          story_no: index + 1,
                          category: ga4Type ? '' : 'seo-pills',
                        },
                      ]}
                    >
                      {itemTitle}
                    </Link>
                  </span>
                ) : null}

                {/* {content ? (
                  <span className={s.sliderItemHeading}>
                    <Link
                      key={item.id}
                      to={item.wu || item.link}
                      className="keyword"
                      data-ga={`${getItemGA(
                        content,
                        index + 1,
                        item.wu || item.link,
                      )}`}
                      target={item.target === '_blank' ? item.target : ''}
                    >
                      {`${itemTitle ? ': ' : ''}${content}`}
                    </Link>
                  </span>
                ) : null} */}
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

TrendingSlider.propTypes = {
  topSearches: PropTypes.arrayOf({}),
  title: PropTypes.string,
  ga4Type: PropTypes.string,
};

TrendingSlider.defaultProps = {
  topSearches: [],
  title: '',
  ga4Type: '',
};

export default TrendingSlider;
